var React = require('react');

function HeroCarouselDivider (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(9884.521 22935.633)"},[React.createElement("path",{"d":"M2800.468,793.838l-1355.934-.215-415.7,821,1771.631.215Z","transform":"translate(-10913.358 -23729.123)","fill":"#fff","opacity":"0.43","key":0}),React.createElement("path",{"d":"M2582.668,793.49l-1138.06.133-415.771,821.145,1553.831-.133Z","transform":"translate(-10695.576 -23729.123)","fill":"#fff","opacity":"0.43","key":1})]));
}

HeroCarouselDivider.defaultProps = {"focusable":"false","viewBox":"0 0 1771.631 821.348"};

module.exports = HeroCarouselDivider;

HeroCarouselDivider.default = HeroCarouselDivider;
